// 组件类
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { getTranslation } from "../../utils/utils";

@Component({
  selector: "rs-checkbox-group",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class CheckboxGroupComponent implements OnInit {
  constructor(private ref: ChangeDetectorRef) {}
  @Input() name; // 分组凭证
  @Input() value = [];
  @Input() dataSource = [];
  @Input() orientation: "horizontal" | "vertical" = "horizontal";
  @Input() fields = { text: "text", value: "value", disabled: "disabled" };
  @Input() disabled = false;
  @Input() error = false;

  @Output()
  valueChange = new EventEmitter();
  translation;
  indeterminate = false;
  ngOnInit() {
    console.log("first", this.value);
    this.translation = getTranslation();
  }
  get enabledDataSource() {
    return this.dataSource.filter((item) => !item[this.fields.disabled]) || [];
  }

  onChange(event, option) {
    const originalValue = this.value;
    let result;
    if (event.checked) {
      result = [...originalValue, option[this.fields.value]];
    } else {
      result = originalValue.filter((val) => val !== option[this.fields.value]);
    }
    this.calculateIndeterminate(result);
    this.valueChange.emit(result);
    this.ref.markForCheck();
  }

  onSelectAll(event) {
    if (event.checked) {
      this.valueChange.emit(
        this.dataSource
          .filter((item) => !item[this.fields.disabled])
          .map((item) => item[this.fields.value])
      );
    } else {
      this.valueChange.emit([]);
    }
    this.ref.markForCheck();
  }

  calculateIndeterminate(result) {
    if (result.length === this.enabledDataSource.length) {
      this.indeterminate = false;
    } else if (result.length > 0 && result.length < this.enabledDataSource.length) {
      this.indeterminate = true;
    } else {
      this.indeterminate = false;
    }
  }
}
